import { ReactElement, ReactNode } from "react";
import * as S from './styled'

interface DefaultButtonProps {
  children: ReactNode
}

export function DefaultButton ({children}: DefaultButtonProps): ReactElement {
  return <S.Button>{children}</S.Button>
}